import update from 'immutability-helper'

export const ACTIONS = {
  TOGGLE_LOADING: '@@collectionListing/TOGGLE_LOADING',
  SET_LISTING_DATA: '@@collectionListing/SET_LISTING_DATA',
  SET_LISTING_FILTERS: '@@collectionListing/SET_LISTING_FILTERS',
}

export const STATE_KEYS = {
  LISTING: 'listing',
  CREATE: 'create',
}

export const DEFAULT_STATE = {
  [STATE_KEYS.LISTING]: {
    isLoading: false,
    data: [],
    filters: {},
    meta: {
      pagination: {
        page: 1,
        pageCount: 0,
      },
    },
  },
  [STATE_KEYS.CREATE]: {
    isLoading: false,
  },
}

const collectionReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.TOGGLE_LOADING: {
      const { key, isLoading } = action.payload

      return update(
        state,
        !key
          ? { isLoading: { $set: isLoading } }
          : { [key]: { isLoading: { $set: isLoading } } }
      )
    }

    case ACTIONS.SET_LISTING_DATA: {
      return update(state, {
        [STATE_KEYS.LISTING]: {
          data: { $set: action.payload?.data },
          meta: { $set: action.payload?.meta },
        },
      })
    }

    case ACTIONS.SET_LISTING_FILTERS: {
      return update(state, {
        [STATE_KEYS.LISTING]: {
          filters: { $set: action.payload?.filters },
        },
      })
    }

    default:
      return state
  }
}

export default collectionReducer
